import { useEffect } from "react";
import { RouterProvider } from "react-router";
import { ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import enUS from "antd/locale/en_US";
import { useTranslation } from "react-i18next";
import { router } from "@/router";
import { useThemeStore } from "@/stores/theme";
import { useAuthStore } from "@/stores/auth";
import { useWsStore } from "@/stores/ws";
import { getAntdTheme, applyCssVariables } from "@/theme/tokens";

const antdLocales: Record<string, typeof zhCN> = {
  "zh-CN": zhCN,
  "en-US": enUS,
};

export function App() {
  const { isDark } = useThemeStore();
  const { i18n } = useTranslation();
  const { connect, disconnect } = useWsStore();
  const { accessToken } = useAuthStore();

  useEffect(() => {
    applyCssVariables(isDark);
  }, [isDark]);

  useEffect(() => {
    if (accessToken) {
      connect();
    }
    return () => disconnect();
  }, [accessToken]);

  const antdTheme = getAntdTheme(isDark);
  const antdLocale = antdLocales[i18n.language] || enUS;

  return (
    <ConfigProvider theme={antdTheme} locale={antdLocale}>
      <RouterProvider router={router} />
    </ConfigProvider>
  );
}
